<template>
  <div>
    <!-- ─── 01 · SUMMARY KPIs ─── -->
    <!--  <div class="text-muted small font-weight-bold text-uppercase mb-3">
      01 · สรุปภาพรวมฐานลูกค้า
      <span class="font-weight-normal">— ฐานลูกค้าสุขภาพดีมั้ย?</span>
    </div> -->
    <p class="text-muted small mb-3">
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FILTER_HINT") }}
    </p>

    <b-row class="mb-3">
      <b-col
        v-for="kpi in summaryKpis"
        :key="kpi.key"
        cols="12"
        sm="6"
        lg="3"
        class="mb-3"
      >
        <b-card
          class="h-100 shadow-sm"
          :border-variant="kpi.borderVariant"
          :bg-variant="kpi.bgVariant"
        >
          <div class="text-muted small text-uppercase font-weight-bold mb-2">
            <span
              class="d-inline-block rounded-circle mr-1"
              :style="{
                width: '8px',
                height: '8px',
                background: kpi.dotColor,
                verticalAlign: 'middle',
              }"
            ></span>
            {{ kpi.label }}
            <span v-if="kpi.subLabel" class="font-weight-normal text-lowercase">
              · {{ kpi.subLabel }}</span
            >
          </div>
          <div class="h2 font-weight-bold mb-1" :class="kpi.valueClass">
            {{ formatNumber(kpi.value) }}
            <small v-if="kpi.suffix" class="text-muted font-weight-normal">{{
              kpi.suffix
            }}</small>
          </div>
          <div
            class="d-flex align-items-center flex-wrap"
            style="gap: 6px; font-size: 12px"
          >
            <b-badge :variant="kpi.delta.variant"
              >{{ kpi.delta.icon }} {{ kpi.delta.value }}</b-badge
            >
            <span class="text-muted">{{ kpi.meta }}</span>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Member Cap -->
    <b-card class="mb-4 shadow-sm" bg-variant="dark" text-variant="white">
      <b-row align-v="center">
        <b-col cols="12" md="4" class="mb-3 mb-md-0">
          <div
            class="small text-uppercase font-weight-bold mb-1"
            style="color: rgba(255, 255, 255, 0.5)"
          >
            <span
              class="d-inline-block rounded-circle mr-1"
              style="width: 8px; height: 8px; background: #fbbf24; vertical-align: middle"
            ></span>
            {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.MEMBER_CAP_LABEL") }}
          </div>
          <div class="h2 font-weight-bold mb-0">
            {{ formatNumber(memberCap.current) }}
            <small
              style="color: rgba(255, 255, 255, 0.45); font-size: 14px; font-weight: 400"
            >
              / {{ formatNumber(memberCap.limit) }}
            </small>
          </div>
        </b-col>
        <b-col cols="12" md="8">
          <b-progress
            :max="100"
            height="8px"
            class="mb-2"
            style="background: rgba(255, 255, 255, 0.1)"
          >
            <b-progress-bar
              :value="capPercent"
              :style="{ background: 'linear-gradient(90deg, #fbbf24 0%, #f97316 100%)' }"
            />
          </b-progress>
          <div
            class="d-flex justify-content-between"
            style="font-size: 11px; color: rgba(255, 255, 255, 0.6)"
          >
            <span>
              <strong style="color: #fbbf24">{{ capPercent }}%</strong>
              {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.CAP_IN_USE") }}
            </span>
            <span>{{
              $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.CAP_PLAN", {
                plan: memberCap.plan,
                n: formatNumber(memberCap.remaining),
              })
            }}</span>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <!-- Insight -->
   <!--  <b-alert
      show
      variant="warning"
      class="mb-4 border-0 shadow-sm"
      style="background: #fffbeb"
    >
      <div class="d-flex" style="gap: 10px">
        <span>💡</span>
        <div
          style="font-size: 13px; line-height: 1.7; color: #4a4740"
          v-html="
            insightHtml || $t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.INSIGHT_HTML')
          "
        ></div>
      </div>
    </b-alert> -->

    <!-- ─── 02 · SEGMENT TABS ─── -->
    <div class="text-muted small font-weight-bold text-uppercase mb-3">
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SECTION_TABS_LABEL") }}
      <span class="font-weight-normal">{{
        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SECTION_TABS_HINT")
      }}</span>
    </div>

    <b-card no-body class="shadow-sm">
      <b-tabs v-model="activeTab" card>
        <!-- ── A · ENGAGEMENT ── -->
        <b-tab :title="$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.TAB_ENGAGEMENT')">
          <b-row>
            <!-- Segment list -->
            <b-col cols="12" md="6" class="mb-4 mb-md-0">
              <b-card no-body class="border">
                <div
                  v-for="(seg, idx) in engagementSegments"
                  :key="seg.key"
                  class="d-flex align-items-center px-3 py-3 seg-row"
                  :class="{ 'border-top': idx > 0 }"
                  style="cursor: pointer; gap: 12px"
                  @click="$emit('drilldown', seg.key)"
                >
                  <div
                    class="rounded d-flex align-items-center justify-content-center flex-shrink-0"
                    :class="`seg-icon-${seg.color}`"
                    style="width: 36px; height: 36px; font-size: 16px"
                  >
                    {{ seg.emoji }}
                  </div>
                  <div class="flex-grow-1 min-width-0">
                    <div class="font-weight-bold" style="font-size: 14px">
                      {{ seg.name }}
                    </div>
                    <div class="text-muted" style="font-size: 11px">
                      {{ seg.definition }}
                    </div>
                  </div>
                  <div class="text-right flex-shrink-0">
                    <div class="font-weight-bold" style="font-size: 18px">
                      {{ formatNumber(seg.count) }}
                    </div>
                    <div class="text-muted" style="font-size: 10px">
                      {{ seg.percent }}%
                    </div>
                  </div>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="flex-shrink-0"
                    style="font-size: 11px"
                    @click.stop="$emit('segment-action', seg)"
                    >→ {{ seg.action }}</b-button
                  >
                </div>
              </b-card>
            </b-col>

            <!-- Visualization -->
            <b-col cols="12" md="6">
              <b-card class="border h-100">
                <div class="text-muted small text-uppercase font-weight-bold mb-3">
                  {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.ENG_CHART_TITLE") }}
                </div>

                <div class="rounded overflow-hidden d-flex mb-3" style="height: 32px">
                  <div
                    v-for="seg in engagementSegments.filter((s) => s.key !== 'vip')"
                    :key="seg.key"
                    class="d-flex align-items-center justify-content-center"
                    :class="`seg-stack-${seg.color}`"
                    :style="{
                      width: seg.percent + '%',
                      fontSize: '11px',
                      color: 'white',
                      fontWeight: 600,
                    }"
                  >
                    {{ Math.round(seg.percent) }}%
                  </div>
                </div>

                <div class="d-flex flex-wrap mb-4" style="gap: 12px; font-size: 11px">
                  <div
                    v-for="seg in engagementSegments.filter((s) => s.key !== 'vip')"
                    :key="seg.key"
                    class="d-flex align-items-center"
                    style="gap: 5px"
                  >
                    <div
                      class="rounded"
                      :class="`seg-stack-${seg.color}`"
                      style="width: 10px; height: 10px"
                    ></div>
                    {{ seg.name }}
                  </div>
                </div>

                <!-- Trend -->
                <div class="pt-3 border-top">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="text-muted small text-uppercase font-weight-bold">
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.TREND_ACTIVE_LABEL"
                        )
                      }}
                      {{ trendRange }}
                    </div>
                    <b-button-group size="sm">
                      <b-button
                        v-for="r in ['4w', '12w', '26w']"
                        :key="r"
                        :variant="trendRange === r ? 'dark' : 'outline-secondary'"
                        style="font-size: 10px; padding: 2px 8px"
                        @click="trendRange = r"
                        >{{ r }}</b-button
                      >
                    </b-button-group>
                  </div>
                  <div
                    class="d-flex"
                    style="height: 80px; gap: 3px; align-items: flex-end"
                  >
                    <div
                      v-for="(val, i) in trendData[trendRange]"
                      :key="i"
                      class="flex-fill rounded-top"
                      :style="{
                        height: val + '%',
                        background:
                          i === trendData[trendRange].length - 1 ? '#1a7a50' : '#1e1c18',
                        opacity: i === trendData[trendRange].length - 1 ? 1 : 0.75,
                      }"
                    ></div>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-1 text-muted"
                    style="font-size: 9px"
                  >
                    <span v-for="lbl in trendAxis[trendRange]" :key="lbl">{{ lbl }}</span>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- ── B · RECEIPT ACTIVITY ── -->
        <b-tab
          :title="$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.TAB_RECEIPT_ACTIVITY')"
        >
          <b-row>
            <!-- Receipt distribution -->
            <b-col cols="12" md="7" class="mb-4">
              <b-card class="border h-100">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-3"
                  style="gap: 8px"
                >
                  <div class="font-weight-bold" style="font-size: 14px">
                    {{
                      $t(
                        "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.RECEIPT_DIST_TITLE"
                      )
                    }}
                  </div>
                  <div class="text-muted small">
                    {{
                      $t(
                        "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.RECEIPT_DIST_SUB",
                        { n: formatNumber(totalMembers) }
                      )
                    }}
                  </div>
                </div>

                <div v-for="row in receiptDistribution" :key="row.label" class="mb-2">
                  <div
                    class="d-flex justify-content-between mb-1"
                    style="font-size: 12px"
                  >
                    <span class="font-weight-medium">
                      {{ row.label }}
                      <span v-if="row.star" class="text-warning">⭐</span>
                    </span>
                    <span class="text-muted" style="font-family: monospace">
                      {{ formatNumber(row.count) }} ({{ row.percent }}%)
                    </span>
                  </div>
                  <b-progress :max="100" height="10px" class="rounded-pill">
                    <b-progress-bar
                      :value="row.percent"
                      :class="`dist-bar-${row.colorClass}`"
                    />
                  </b-progress>
                </div>

                <div class="mt-4 pt-3 border-top">
                  <div class="text-muted small text-uppercase font-weight-bold mb-2">
                    {{
                      $t(
                        "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.RECEIPT_BREAK_TITLE",
                        { n: formatNumber(receiptBreakdown.total) }
                      )
                    }}
                  </div>
                  <div class="d-flex rounded overflow-hidden" style="height: 24px">
                    <div
                      class="d-flex align-items-center justify-content-center"
                      :style="{
                        width: receiptBreakdown.ai + '%',
                        background: '#1a7a50',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 600,
                      }"
                    >
                      AI · {{ receiptBreakdown.ai }}%
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-center"
                      :style="{
                        width: receiptBreakdown.manual + '%',
                        background: '#4a4740',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 600,
                      }"
                    >
                      Manual · {{ receiptBreakdown.manual }}%
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-center"
                      :style="{
                        width: receiptBreakdown.reject + '%',
                        background: '#b91c1c',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 600,
                      }"
                    >
                      Reject · {{ receiptBreakdown.reject }}%
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>

            <!-- Spend tier -->
            <b-col cols="12" md="5" class="mb-4">
              <b-card class="border h-100">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-3"
                  style="gap: 8px"
                >
                  <div class="font-weight-bold" style="font-size: 14px">
                    {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SPEND_TITLE") }}
                  </div>
                  <div class="text-muted small">
                    {{
                      $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SPEND_SUB", {
                        n: formatNumber(spendApprovedCount),
                      })
                    }}
                  </div>
                </div>

                <b-table-simple small bordered responsive class="mb-3">
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th class="small text-uppercase text-muted">{{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SPEND_COL_TIER")
                      }}</b-th>
                      <b-th class="small text-uppercase text-muted text-right">{{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SPEND_COL_RANGE")
                      }}</b-th>
                      <b-th class="small text-uppercase text-muted text-right">{{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.SPEND_COL_COUNT")
                      }}</b-th>
                      <b-th class="small text-uppercase text-muted text-right">%</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="t in spendTiers" :key="t.tier">
                      <b-td>
                        <b-badge :variant="t.badgeVariant" class="font-weight-bold">{{
                          t.tier
                        }}</b-badge>
                      </b-td>
                      <b-td class="text-right small" style="font-family: monospace">{{
                        t.range
                      }}</b-td>
                      <b-td class="text-right small" style="font-family: monospace">{{
                        formatNumber(t.count)
                      }}</b-td>
                      <b-td class="text-right small" style="font-family: monospace"
                        >{{ t.percent }}%</b-td
                      >
                    </b-tr>
                  </b-tbody>
                </b-table-simple>

                <div
                  class="p-3 rounded"
                  style="
                    background: #f3f0e8;
                    font-size: 11px;
                    color: #4a4740;
                    line-height: 1.6;
                  "
                >
                  {{
                    $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.PARETO_NOTE", {
                      pct: paretoInsight.highPct,
                      revenue: paretoInsight.totalRevenue,
                      share: paretoInsight.sharePct,
                    })
                  }}
                </div>
              </b-card>
            </b-col>

            <!-- Frequency -->
            <b-col cols="12" class="mb-4">
              <b-card class="border">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-3"
                  style="gap: 8px"
                >
                  <div class="font-weight-bold" style="font-size: 14px">
                    {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FREQ_TITLE") }}
                  </div>
                  <div class="text-muted small">
                    {{
                      $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FREQ_SUB", {
                        n: formatNumber(frequencyTotal),
                      })
                    }}
                  </div>
                </div>
                <b-row>
                  <b-col
                    v-for="cell in frequencyCells"
                    :key="cell.label"
                    cols="6"
                    md="3"
                    class="mb-3"
                  >
                    <div
                      class="text-center p-3 rounded border h-100"
                      :class="`freq-cell-${cell.heat}`"
                    >
                      <div
                        class="text-muted font-weight-bold mb-1"
                        style="
                          font-size: 10px;
                          letter-spacing: 0.05em;
                          text-transform: uppercase;
                        "
                      >
                        {{ cell.label }}
                      </div>
                      <div class="font-weight-bold" style="font-size: 22px">
                        {{ formatNumber(cell.value) }}
                      </div>
                      <div class="text-muted" style="font-size: 10px">
                        {{ cell.percent }}%
                        <span v-if="cell.tag"> · {{ cell.tag }}</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <!-- Fraud flag -->
            <b-col cols="12">
              <b-card class="border border-danger" style="background: #fef2f2">
                <div class="d-flex align-items-start" style="gap: 14px">
                  <div style="font-size: 18px">⚠️</div>
                  <div class="flex-grow-1">
                    <div
                      class="font-weight-bold text-danger mb-1"
                      style="font-size: 13px"
                    >
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FRAUD_TITLE", {
                          n: fraudFlag.count,
                        })
                      }}
                    </div>
                    <div class="text-dark" style="font-size: 12px; line-height: 1.6">
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FRAUD_BODY", {
                          threshold: fraudFlag.threshold,
                          average: fraudFlag.average,
                        })
                      }}
                    </div>
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      class="mt-2 font-weight-bold"
                      style="font-size: 11px"
                      @click="$bvModal.show('modal-fraud-members')"
                      >{{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FRAUD_CTA", {
                          n: fraudFlag.count,
                        })
                      }}</b-button
                    >
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- ── Fraud Members Modal ── -->
    <b-modal
      id="modal-fraud-members"
      size="lg"
      :title="`⚠️ รายชื่อสมาชิกที่ Reject ผิดปกติ (${fraudFlag.count} คน)`"
      ok-only
      ok-title="ปิด"
      ok-variant="secondary"
      @show="fetchFraudMembers"
    >
      <!-- Search + summary bar -->
      <div
        class="d-flex align-items-center justify-content-between flex-wrap mb-3"
        style="gap: 8px"
      >
        <div class="small text-muted">
          อัตรา Reject เกิน
          <strong class="text-danger">{{ fraudFlag.threshold }}%</strong>
          · ค่าเฉลี่ยกลุ่มนี้
          <strong class="text-danger">{{ fraudFlag.average }}%</strong>
        </div>
        <b-form-input
          v-model="fraudSearch"
          size="sm"
          placeholder="ค้นหาชื่อ / เบอร์..."
          style="max-width: 200px"
        />
      </div>

      <!-- Loading -->
      <div v-if="fraudLoading" class="text-center py-5 text-muted">
        <b-spinner small class="mr-2" />
        กำลังโหลด...
      </div>

      <!-- Table -->
      <b-table-simple v-else small bordered responsive hover>
        <b-thead head-variant="light">
          <b-tr>
            <b-th>#</b-th>
            <b-th>ชื่อสมาชิก</b-th>
            <b-th>เบอร์โทร</b-th>
            <b-th class="text-right">ใบเสร็จทั้งหมด</b-th>
            <b-th class="text-right">Reject</b-th>
            <b-th class="text-right">อัตรา Reject</b-th>
            <b-th class="text-center">Segment</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(m, i) in filteredFraudMembers" :key="m.id">
            <b-td class="text-muted small">{{
              (fraudPage - 1) * fraudPerPage + i + 1
            }}</b-td>
            <b-td class="font-weight-bold">{{ m.name }}</b-td>
            <b-td class="text-muted small" style="font-family: monospace">
              {{ m.phone }}
            </b-td>
            <b-td class="text-right small" style="font-family: monospace">
              {{ m.totalReceipts }}
            </b-td>
            <b-td
              class="text-right small text-danger font-weight-bold"
              style="font-family: monospace"
            >
              {{ m.rejectCount }}
            </b-td>
            <b-td class="text-right">
              <b-badge
                :variant="m.rejectRate >= 70 ? 'danger' : 'warning'"
                class="font-weight-bold"
              >
                {{ m.rejectRate }}%
              </b-badge>
            </b-td>
            <b-td class="text-center">
              <b-badge
                :variant="
                  m.segment === 'active'
                    ? 'success'
                    : m.segment === 'risk'
                    ? 'warning'
                    : 'secondary'
                "
                style="font-size: 10px"
              >
                {{ m.segment || "—" }}
              </b-badge>
            </b-td>
          </b-tr>
          <b-tr v-if="filteredFraudMembers.length === 0">
            <b-td colspan="7" class="text-center text-muted py-4"> ไม่พบข้อมูล </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div
        class="d-flex align-items-center justify-content-between flex-wrap mt-3"
        style="gap: 8px"
      >
        <div class="text-muted small">
          <template v-if="fraudTotal > 0">
            แสดง {{ (fraudPage - 1) * fraudPerPage + 1 }}–{{
              Math.min(fraudPage * fraudPerPage, fraudTotal)
            }}
            จาก {{ fraudTotal }} รายการ
          </template>
          <template v-else>ไม่พบรายการ</template>
        </div>
        <b-pagination
          v-if="fraudTotal > fraudPerPage"
          v-model="fraudPage"
          :total-rows="fraudTotal"
          :per-page="fraudPerPage"
          size="sm"
          pills
          class="mb-0"
          @change="onFraudPageChange"
        />
      </div>
    </b-modal>

    <!-- Footer -->
    <div
      class="text-muted mt-4 pt-3 border-top"
      style="font-size: 11px; line-height: 1.7"
    >
      <strong class="text-secondary">{{
        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FOOTER_CRITERIA")
      }}</strong>
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FOOTER_CALC") }} ·
      <strong class="text-secondary">Active</strong>
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FOOTER_ACTIVE_DEF") }} ·
      <strong class="text-secondary">Member Cap</strong>
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.FOOTER_CAP_DEF") }}
    </div>
  </div>
</template>

<script>
import {
  SEGMENTS_SUMMARY_CAMPAIGN,
  SEGMENTS_ENGAGEMENT_CAMPAIGN,
  SEGMENTS_RECEIPT_ACTIVITY_CAMPAIGN,
  SEGMENTS_FRAUD_MEMBERS_CAMPAIGN,
} from "@/core/services/store/campaign.module";

export default {
  name: "CampaignSegmentsTab",

  props: {
    campaign_id: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      activeTab: 0,
      trendRange: "12w",

      // loading states
      summaryLoading: false,
      engagementLoading: false,
      receiptLoading: false,

      // ── Summary ──
      summaryKpis: this.defaultKpis(),
      memberCap: { current: 0, limit: 0, remaining: 0, plan: "—" },
      insightHtml: "",

      // ── Engagement ──
      engagementSegments: [],
      trendData: { "4w": [], "12w": [], "26w": [] },
      trendAxis: { "4w": [], "12w": [], "26w": [] },

      // ── Receipt Activity ──
      totalMembers: 0,
      receiptDistribution: [],
      receiptBreakdown: { total: 0, ai: 0, manual: 0, reject: 0 },
      spendApprovedCount: 0,
      spendTiers: [],
      paretoInsight: { highPct: 0, totalRevenue: "—", sharePct: 0 },
      frequencyTotal: 0,
      frequencyCells: [],
      fraudFlag: { count: 0, threshold: 0, average: 0 },

      // ── Fraud modal ──
      fraudSearch: "",
      fraudLoading: false,
      fraudMembers: [],
      fraudTotal: 0,
      fraudPage: 1,
      fraudPerPage: 20,
    };
  },

  computed: {
    capPercent() {
      if (!this.memberCap.limit) return 0;
      return Math.round((this.memberCap.current / this.memberCap.limit) * 1000) / 10;
    },
    filteredFraudMembers() {
      return this.fraudMembers;
    },
  },

  watch: {
    campaign_id(newId, oldId) {
      if (!newId || newId === oldId) return;
      this.fetchAll();
    },
    trendRange() {
      this.fetchEngagement();
    },
    fraudSearch() {
      this.fraudPage = 1;
      this.fetchFraudMembers();
    },
  },

  mounted() {
    this.fetchAll();
  },

  methods: {
    fetchAll() {
      this.fetchSummary();
      this.fetchEngagement();
      this.fetchReceiptActivity();
    },

    async fetchSummary() {
      this.summaryLoading = true;
      try {
        const { data } = await this.$store.dispatch(SEGMENTS_SUMMARY_CAMPAIGN, {
          id: this.campaign_id,
        });
        if (data.status === "success" && data.data) {
          const d = data.data;
          this.summaryKpis = this.buildKpis(d);
          this.memberCap = d.memberCap || this.memberCap;
          this.insightHtml = d.insightHtml || "";
        }
      } catch (e) {
        // keep defaults on error
      } finally {
        this.summaryLoading = false;
      }
    },

    async fetchEngagement() {
      this.engagementLoading = true;
      try {
        const { data } = await this.$store.dispatch(SEGMENTS_ENGAGEMENT_CAMPAIGN, {
          id: this.campaign_id,
          params: { trend_range: this.trendRange },
        });
        if (data.status === "success" && data.data) {
          const d = data.data;
          this.engagementSegments = this.mapSegments(d.segments || []);
          if (d.trendData) this.trendData = d.trendData;
          if (d.trendAxis) this.trendAxis = d.trendAxis;
        }
      } catch (e) {
        // keep defaults on error
      } finally {
        this.engagementLoading = false;
      }
    },

    async fetchReceiptActivity() {
      this.receiptLoading = true;
      try {
        const res = await this.$store.dispatch(SEGMENTS_RECEIPT_ACTIVITY_CAMPAIGN, {
          id: this.campaign_id,
        });
        const data = res.data;
        if (data.status === "success" && data.data) {
          const d = data.data;
          this.totalMembers = d.totalMembers || 0;
          this.receiptDistribution = this.mapReceiptDist(d.receiptDistribution || []);
          this.receiptBreakdown = d.receiptBreakdown || this.receiptBreakdown;
          this.spendApprovedCount = d.spendApprovedCount || 0;
          this.spendTiers = this.mapSpendTiers(d.spendTiers || []);
          this.paretoInsight = d.paretoInsight || this.paretoInsight;
          this.frequencyTotal = d.frequencyTotal || 0;
          this.frequencyCells = this.mapFrequencyCells(d.frequencyCells || []);
          this.fraudFlag = d.fraudFlag || this.fraudFlag;
        }
      } catch (e) {
        //log
      } finally {
        this.receiptLoading = false;
      }
    },

    onFraudPageChange(page) {
      this.fraudPage = page;
      this.fetchFraudMembers();
    },

    async fetchFraudMembers() {
      this.fraudLoading = true;
      try {
        const res = await this.$store.dispatch(SEGMENTS_FRAUD_MEMBERS_CAMPAIGN, {
          id: this.campaign_id,
          params: {
            search: this.fraudSearch || undefined,
            page: this.fraudPage.toString(),
            perPage: this.fraudPerPage.toString(),
          },
        });
        const data = res.data;
        if (data.status === "success" && data.data) {
          this.fraudMembers = data.data.data || data.data.members || [];
          this.fraudTotal = data.data.total || 0;
        }
      } catch (e) {
        // keep defaults on error
      } finally {
        this.fraudLoading = false;
      }
    },

    // ── Mappers: แปลง API response → format ที่ template ใช้ ──

    buildKpis(d) {
      const S = "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.";
      return [
        {
          key: "total",
          borderVariant: "light",
          bgVariant: "white",
          dotColor: "#1e1c18",
          label: this.$t(S + "KPI_TOTAL_LABEL"),
          value: d.totalMembers || 0,
          suffix: this.$t(S + "KPI_TOTAL_SUFFIX"),
          valueClass: "text-dark",
          delta: {
            variant: "success",
            icon: d.totalDelta >= 0 ? "↑" : "↓",
            value: this.fmtDelta(d.totalDelta),
          },
          meta: d.totalMeta || this.$t(S + "KPI_TOTAL_META"),
        },
        {
          key: "active",
          borderVariant: "success",
          bgVariant: "white",
          dotColor: "#1a7a50",
          label: this.$t(S + "KPI_ACTIVE_LABEL"),
          subLabel: this.$t(S + "KPI_ACTIVE_SUB"),
          value: d.activeMembers || 0,
          valueClass: "text-success",
          delta: {
            variant: "success",
            icon: d.activeDelta >= 0 ? "↑" : "↓",
            value: this.fmtDelta(d.activeDelta),
          },
          meta: d.activeMeta || this.$t(S + "KPI_ACTIVE_META"),
        },
        {
          key: "risk",
          borderVariant: "warning",
          bgVariant: "white",
          dotColor: "#b45309",
          label: this.$t(S + "KPI_RISK_LABEL"),
          subLabel: this.$t(S + "KPI_RISK_SUB"),
          value: d.atRiskMembers || 0,
          valueClass: "text-warning",
          delta: {
            variant: "warning",
            icon: d.atRiskDelta >= 0 ? "↑" : "↓",
            value: this.fmtDelta(d.atRiskDelta),
          },
          meta: d.atRiskMeta || this.$t(S + "KPI_RISK_META"),
        },
        {
          key: "lapsed",
          borderVariant: "danger",
          bgVariant: "white",
          dotColor: "#b91c1c",
          label: this.$t(S + "KPI_LAPSED_LABEL"),
          subLabel: this.$t(S + "KPI_LAPSED_SUB"),
          value: d.lapsedMembers || 0,
          valueClass: "text-danger",
          delta: {
            variant: "secondary",
            icon: d.lapsedDelta >= 0 ? "↑" : "↓",
            value: this.fmtDelta(d.lapsedDelta),
          },
          meta: d.lapsedMeta || this.$t(S + "KPI_LAPSED_META"),
        },
      ];
    },

    mapSegments(segs) {
      const S = "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.";
      const meta = {
        new: {
          color: "new",
          emoji: "🔵",
          nameKey: S + "SEG_NEW_NAME",
          defKey: S + "SEG_NEW_DEF",
          actionKey: S + "SEG_NEW_ACTION",
        },
        active: {
          color: "active",
          emoji: "🟢",
          nameKey: S + "SEG_ACTIVE_NAME",
          defKey: S + "SEG_ACTIVE_DEF",
          actionKey: S + "SEG_ACTIVE_ACTION",
        },
        risk: {
          color: "risk",
          emoji: "🟡",
          nameKey: S + "SEG_RISK_NAME",
          defKey: S + "SEG_RISK_DEF",
          actionKey: S + "SEG_RISK_ACTION",
        },
        lapsed: {
          color: "lapsed",
          emoji: "🔴",
          nameKey: S + "SEG_LAPSED_NAME",
          defKey: S + "SEG_LAPSED_DEF",
          actionKey: S + "SEG_LAPSED_ACTION",
        },
        vip: {
          color: "vip",
          emoji: "⭐",
          nameKey: S + "SEG_VIP_NAME",
          defKey: S + "SEG_VIP_DEF",
          actionKey: S + "SEG_VIP_ACTION",
        },
      };
      return segs.map((s) => {
        const m = meta[s.key] || {};
        return {
          key: s.key,
          color: m.color || s.key,
          emoji: m.emoji || "●",
          count: s.count || 0,
          percent: s.percent || 0,
          name: this.$t(m.nameKey || s.key),
          definition: this.$t(m.defKey || s.key),
          action: this.$t(m.actionKey || s.key),
        };
      });
    },

    mapReceiptDist(dist) {
      const S = "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.";
      const colorMap = { 0: "b1", 1: "b2", "2-5": "b3", "6+": "b4" };
      const labelMap = {
        0: S + "DIST_0",
        1: S + "DIST_1",
        "2-5": S + "DIST_2_5",
        "6+": S + "DIST_6_PLUS",
      };
      return dist.map((r) => ({
        label: this.$t(labelMap[r.bucket] || r.bucket),
        count: r.count || 0,
        percent: r.percent || 0,
        colorClass: colorMap[r.bucket] || "b1",
        star: r.bucket === "6+",
      }));
    },

    mapSpendTiers(tiers) {
      const variantMap = { LOW: "secondary", MID: "primary", HIGH: "warning" };
      return tiers.map((t) => ({
        tier: t.tier,
        badgeVariant: variantMap[t.tier] || "secondary",
        range: t.range || "—",
        count: t.count || 0,
        percent: t.percent || 0,
      }));
    },

    mapFrequencyCells(cells) {
      const S = "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.SEGMENTS.";
      const meta = {
        weekly: {
          labelKey: S + "FREQ_WEEKLY",
          heat: "hot",
          tagKey: S + "FREQ_LOYAL_TAG",
        },
        monthly: { labelKey: S + "FREQ_MONTHLY", heat: "warm", tagKey: null },
        "bi-monthly": {
          labelKey: S + "FREQ_BI_MONTHLY",
          heat: "cool",
          tagKey: null,
        },
        occasional: {
          labelKey: S + "FREQ_OCCASIONAL",
          heat: "cool",
          tagKey: null,
        },
      };
      return cells.map((c) => {
        const m = meta[c.bucket] || {};
        return {
          label: m.labelKey ? this.$t(m.labelKey) : c.bucket,
          value: c.count || 0,
          percent: c.percent || 0,
          heat: m.heat || "cool",
          tag: m.tagKey ? this.$t(m.tagKey) : null,
        };
      });
    },

    defaultKpis() {
      return [
        {
          key: "total",
          borderVariant: "light",
          bgVariant: "white",
          dotColor: "#1e1c18",
          label: "—",
          value: 0,
          suffix: "",
          valueClass: "text-dark",
          delta: { variant: "secondary", icon: "—", value: "—" },
          meta: "",
        },
        {
          key: "active",
          borderVariant: "success",
          bgVariant: "white",
          dotColor: "#1a7a50",
          label: "—",
          value: 0,
          valueClass: "text-success",
          delta: { variant: "secondary", icon: "—", value: "—" },
          meta: "",
        },
        {
          key: "risk",
          borderVariant: "warning",
          bgVariant: "white",
          dotColor: "#b45309",
          label: "—",
          value: 0,
          valueClass: "text-warning",
          delta: { variant: "secondary", icon: "—", value: "—" },
          meta: "",
        },
        {
          key: "lapsed",
          borderVariant: "danger",
          bgVariant: "white",
          dotColor: "#b91c1c",
          label: "—",
          value: 0,
          valueClass: "text-danger",
          delta: { variant: "secondary", icon: "—", value: "—" },
          meta: "",
        },
      ];
    },

    fmtDelta(v) {
      if (v == null) return "—";
      return (v >= 0 ? "+" : "") + v + "%";
    },

    formatNumber(n) {
      if (n == null) return "—";
      return new Intl.NumberFormat("en-US").format(n);
    },
  },
};
</script>

<style scoped>
.seg-icon-new {
  background: #eff4fc;
  border: 1px solid #b8d0f0;
}
.seg-icon-active {
  background: #edf7f2;
  border: 1px solid #a8d8be;
}
.seg-icon-risk {
  background: #fef3e2;
  border: 1px solid #f5d08a;
}
.seg-icon-lapsed {
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.seg-icon-vip {
  background: #f3effe;
  border: 1px solid #c4a8f5;
}

.seg-stack-new {
  background: #2563a8;
}
.seg-stack-active {
  background: #1a7a50;
}
.seg-stack-risk {
  background: #b45309;
}
.seg-stack-lapsed {
  background: #b91c1c;
}

.dist-bar-b1 {
  background: #cfe1f5;
}
.dist-bar-b2 {
  background: #88b8e5;
}
.dist-bar-b3 {
  background: #2563a8;
}
.dist-bar-b4 {
  background: #7c3aed;
}

.freq-cell-hot {
  background: #f3effe;
  border-color: #c4a8f5 !important;
}
.freq-cell-warm {
  background: #eff4fc;
  border-color: #b8d0f0 !important;
}
.freq-cell-cool {
  background: #f9f8f5;
}

.seg-row:hover {
  background-color: #f9f8f5;
}
</style>
